import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MainLayout } from "./layouts/MainLayout";
import { routeConfig } from "./config/routeConfig";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import ToastContainer from "./components/ToastContainer";
import Home from "./pages/Home";
import ProductRecycler from "./pages/ProductRecycler";
import Cart from "./pages/Cart";
import OrderScreen from "./pages/OrderScreen";
import Profile from "./pages/Profile";
import ProductDetails from "./pages/ProductDetails";
import Order from "./pages/Order";
import AddDetails from "./pages/AddDetails";
import Auth from "./pages/Auth";
import OTP from "./pages/OTP";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Address from "./pages/Address";
import ApiInitializer from "./components/ApiInitializer";

const componentMap: Record<string, JSX.Element> = {
  Home: <Home />,
  Cart: <Cart />,
  Checkout: <OrderScreen />,
  Favourite: <ProductRecycler type="favourites" />,
  Category: <ProductRecycler type="category" />,
  Search: <ProductRecycler type = "search"/>,
  Profile: <Profile />,
  ProductDetails: <ProductDetails />,
  Order: <Order />,
  Signup: <AddDetails />,
  Auth: <Auth />,
  OTP: <OTP />,
  Privacy: <PrivacyPolicy />,
  Terms: <TermsOfUse />,
  Address: <Address/>
};

export default function App() {
  return (
    <ToastProvider>
      <ApiInitializer>
        <AuthProvider>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <ToastContainer />
            <Routes>
              <Route element={<MainLayout />}>
                {routeConfig.main.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={componentMap[route.element]}
                  />
                ))}
              </Route>

              <Route path="/information">
                {routeConfig.information.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={componentMap[route.element]}
                  />
                ))}
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ApiInitializer>
    </ToastProvider>
  );
}
